export default "__VITE_ASSET__DukBw1pj__"